

































































































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  useContext,
  useRouter,
} from "@nuxtjs/composition-api";
import { changeImage, checkHttpLink, decodeUid } from "~/helpers";
import { useUiState } from "~/composables";
import { useCart } from "~/modules/checkout/composables/useCart";
import { useUser } from "~/modules/customer/composables/useUser";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { usePageStore } from "~/stores/page";

export default defineComponent({
  name: "HeaderS",
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const router = useRouter();
    const { routeData } = usePageStore();
    const { app } = useContext();
    const { loadTotalQty: loadCartTotalQty, cart } = useCart();
    const { isAuthenticated } = useUser();
    const {
      toggleCartSidebar,
      isCartSidebarOpen,
      isSearchPopupOpen,
      toggleSearchPopup,
      toggleLoginModal,
    } = useUiState();

    const menuData = computed(() => {
      return props.item?.menu_data || [];
    });

    const { activeCategoryById } = useTraverseCategory();
    const activeCategoryByUid = computed(() => {
      return activeCategoryById(decodeUid(routeData?.uid));
    });
    const categoryUrlPath = computed(() => {
      return activeCategoryByUid.value?.url_path || "";
    });

    const isFixed = ref(false);
    const isActiveMenu = ref(false);
    const activeIndex = ref(null);
    const styleElement = ref(null);
    const menu = ref(null);
    const toggleBtn = ref(null);

    const handleScroll = () => {
      isFixed.value = window.scrollY > 200;
    };
    const toggleMenu = () => {
      isActiveMenu.value = !isActiveMenu.value;
    };
    const toggleActive = (index) => {
      activeIndex.value = activeIndex.value === index ? null : index;
    };

    const handleClickOutside = (event) => {
      const menuEl = menu.value as HTMLElement;
      const toggleBtnEl = toggleBtn.value as HTMLElement;

      if (
        menuEl &&
        toggleBtnEl &&
        !menuEl.contains(event.target as Node) &&
        !toggleBtnEl.contains(event.target as Node)
      ) {
        isActiveMenu.value = false;
        activeIndex.value = null;
      }
    };

    const handleAccountClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: "customer-my-profile" }));
      } else {
        toggleLoginModal();
      }
    };
    const handleAccountMobileClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: "customer-my-account" }));
      } else {
        toggleLoginModal();
      }
    };

    const addGlobalStyle = () => {
      if (styleElement.value) return;
      styleElement.value = document.createElement("style");
      styleElement.value.type = "text/css";
      styleElement.value.textContent =
        ".menu,.site-header,.site-page-top,.header__promotion,#oc-widget,.footer__application,.footer__subscribe { display: none !important; }";
      document.head.appendChild(styleElement.value);
    };

    const removeGlobalStyle = () => {
      if (styleElement.value) {
        document.head.removeChild(styleElement.value);
        styleElement.value = null;
      }
    };

    onMounted(async () => {
      addGlobalStyle();
      if (app.$device.isDesktop) {
        await loadCartTotalQty();
      }
      window.addEventListener("scroll", handleScroll);
      document.addEventListener("click", handleClickOutside);
    });
    onUnmounted(() => {
      removeGlobalStyle();
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
    });
    return {
      menuData,
      menu,
      toggleBtn,
      addGlobalStyle,
      removeGlobalStyle,
      styleElement,
      changeImage,
      cartTotalItems: computed(() => cart.value?.total_quantity ?? 0),
      toggleCartSidebar,
      isCartSidebarOpen,
      checkHttpLink,
      toggleActive,
      isFixed,
      isActiveMenu,
      activeIndex,
      handleScroll,
      toggleMenu,
      handleClickOutside,
      toggleSearchPopup,
      handleAccountClick,
      handleAccountMobileClick,
      categoryUrlPath,
    };
  },
});
